/*
 * Copyright (c) 2026 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {IconProps} from '../../types/types';
import useIconDLS from '../useIconDLS';

/**
 * Defines the Design Language System (DLS) Material Checkbox Icon component.
 */
export const MaterialCheckIcon = (props: IconProps) => {
  const {iconSize, iconColor} = useIconDLS(props);
  return (
    <svg width={iconSize} height={iconSize} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path d='M20 7.26174L9.02857 18L4 13.0783L5.28914 11.8166L9.02857 15.4676L18.7109 6L20 7.26174Z' fill={iconColor} />
    </svg>
  );
};

export default MaterialCheckIcon;
